module.exports = __webpack_public_path__ + "img/python.ee16cba0.png";